import { useCallback, useState } from 'react';
import { getDirectFeedMilestone, getPlacementAfterMilestone } from '../utils/connectedMilestonePlacement';

/**
 * Creating a mission downstream of a milestone may need a before/after choice
 * before the node is actually inserted.
 */
export function useConnectedNodePlacement({ tasks, handleCreateConnectedNode, pasteConnectedToHost }) {
  const [pendingMilestonePlacement, setPendingMilestonePlacement] = useState(null);

  const createConnectedNode = useCallback((sourceTaskId, nodeType, branch, options) => {
    if (nodeType === 'paste') {
      pasteConnectedToHost?.(sourceTaskId, branch);
      return;
    }
    if (!options?.placement) {
      const afterMilestone = getPlacementAfterMilestone(sourceTaskId, tasks);
      if (afterMilestone) {
        handleCreateConnectedNode(afterMilestone.hostTaskId, nodeType, branch, {
          placement: afterMilestone.placement,
          feed: afterMilestone.feed,
          afterMilestoneId: afterMilestone.afterMilestoneId,
          insertBeforeHost: afterMilestone.insertBeforeHost,
        });
        return;
      }

      const feed = getDirectFeedMilestone(sourceTaskId, tasks);
      if (feed) {
        setPendingMilestonePlacement({ sourceTaskId, nodeType, branch, feed });
        return;
      }
    }
    handleCreateConnectedNode(sourceTaskId, nodeType, branch, options);
  }, [tasks, handleCreateConnectedNode, pasteConnectedToHost]);

  const confirmMilestonePlacement = useCallback((placement) => {
    const pending = pendingMilestonePlacement;
    setPendingMilestonePlacement(null);
    if (!pending) return;
    handleCreateConnectedNode(pending.sourceTaskId, pending.nodeType, pending.branch, {
      placement,
      feed: pending.feed,
    });
  }, [pendingMilestonePlacement, handleCreateConnectedNode]);

  return {
    pendingMilestonePlacement,
    setPendingMilestonePlacement,
    createConnectedNode,
    confirmMilestonePlacement,
  };
}
